<div class="static-page">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <a href="/#/home" title="WellBrain">
          <img src="/assets/images/WellBrain.png" alt="WellBrain logo" class="header-logo">
        </a>
        <div class="markdown-content">
          <h1 id="wellbrain-privacy-policy">Wellbrain Privacy Policy</h1>
          <p>Effective Date:
            <strong>08.23.2016</strong>
          </p>
          <p>Welcome to WellBrain ("WellBrain," "we," "us" or "our"). WellBrain provides a fast, beautiful and fun way for you
            to train yourself to strengthen your mind-body awareness through meditation and share media through our content-sharing
            platform with other users. Our Privacy Policy explains how we and some of the companies we work with collect,
            use, share and protect information in relation to our mobile services, web site, and any software provided on
            or in connection with WellBrain services (collectively, the
            <strong>"Service"</strong>), and your choices about the collection and use of your information. By using our Service
            you understand and agree that we are providing a platform for you to post content, including photos, comments
            and other materials (
            <strong>"User Content"</strong>), to the Service and to share User Content publicly. This means that other Users may
            search for, see, use, or share any of your User Content that you make publicly available through the Service,
            consistent with the terms and conditions of this Privacy Policy and our Terms and Conditions and Medical Disclaimer.
            Lastly our Privacy Policy is also subject to these documents as well. All three are available at all times at
            www.wellbrain.io. Please feel free to visit this information accordingly.</p>
          <p>Our Policy applies to all visitors, patients, medical staff, physicians, users, and others who access the Service
            (
            <strong>"Users"</strong>).</p>
          <ol>
            <li>
              <h2 id="information-we-collect">Information we collect</h2>
              <p> We collect the following types of information.</p>
              <p>
                <strong>Information you provide us directly:</strong>
              </p>
              <ul>
                <li>Your username, password and e-mail address when you register for an WellBrain account.</li>
                <li>Profile information that you provide for your user profile (e.g., first and last name, picture, phone number).
                  This information allows us to help you or others be "found" on WellBrain.</li>
                <li>User Content (e.g., photos, comments, and other materials) that you post to the Service.</li>
                <li>Communications between you and WellBrain. For example, we may send you - Service-related emails (e.g., account
                  verification, changes/updates to features of the Service, technical and security notices). Note that you
                  may not opt out of Service-related e-mails.</li>
                <li>
                  <p>Patient Health Information (PHI). Specifically we do collect medically administered information in the
                    medical or other HIPAA sanctioned offices. PHI is further defined in the HIPAA guidelines. Additionally,
                    we collect biofeedback data with respect to third party devices used in conjunction with this Service.</p>
                  <p>
                    <strong>Analytics information:</strong>
                  </p>
                </li>
                <li>
                  <p>We use third-party analytics tools to help us measure traffic and usage trends for the Service. These tools
                    collect information sent by your device or our Service, including the web pages you visit, add-ons, and
                    other information that assists us in improving the Service. We collect and use this analytics information
                    with analytics information from other Users so that it cannot reasonably be used to identify any particular
                    individual User. Our analytics will in no manner reveal Patient Health Information.</p>
                  <p>
                    <strong>Cookies and similar technologies:</strong>
                  </p>
                </li>
                <li>
                  <p>When you visit the Service, we may use cookies and similar technologies like pixels, web beacons, and local
                    storage to collect information about how you use WellBrain and provide features to you.</p>
                </li>
                <li>We may ask advertisers or other partners to serve ads or services to your devices, which may use cookies
                  or similar technologies placed by us or the third party.</li>
                <li>
                  <p>More information is available in our About Cookies section.</p>
                  <p>
                    <strong>Patient Related information:</strong>
                  </p>
                </li>
                <li>
                  <p>When you visit the Service, it may occur at a Physician or Medical Provider office which administers medical
                    related tests you will answer. Additional we do collect, if a 3rd party device is use, various forms
                    of biofeedback either at the Medical Provider office or in use at home. All of this information at no
                    times will be shared with any other party, with the exception of medical personnel who have assigned
                    you this Service. All patient related health information is kept strictly confidential and can never
                    be shared with any other 3rd party as per HIPAA guidelines.</p>
                </li>
              </ul>
            </li>
            <li>
              <h2 id="how-we-use-your-information">How we use your information</h2>
              <p> In addition to some of the specific uses of information we describe in this Privacy Policy, we may use information
                that we receive to:</p>
              <ul>
                <li>help you efficiently access your information after you sign in</li>
                <li>remember information so you will not have to re-enter it during your visit or the next time you visit the
                  Service;</li>
                <li>provide personalized content and information to you and others, which could include online ads or other forms
                  of marketing</li>
                <li>provide, improve, test, and monitor the effectiveness of our Service</li>
                <li>develop and test new products and features</li>
                <li>monitor metrics such as total number of visitors, traffic, and demographic patterns</li>
                <li>diagnose or fix technology problems</li>
                <li>automatically update the WellBrain application on your device</li>
              </ul>
            </li>
            <li>
              <h2 id="sharing-of-your-information">Sharing of your information</h2>
              <p> We will not rent or sell your information to third parties outside WellBrain (or the group of companies of
                which WellBrain is a part) without your consent, except as noted in this Policy.</p>
              <p>
                <strong>Parties with whom we may share your information:</strong>
              </p>
              <ul>
                <li>We may share User Content and your information (including but not limited to, information from cookies, log
                  files, device identifiers, location data, and usage data) with businesses that are legally part of the
                  same group of companies that WellBrain is part of, or that become part of that group ("Affiliates"). Affiliates
                  may use this information to help provide, understand, and improve the Service (including by providing analytics)
                  and Affiliates' own services (including by providing you with better and more relevant experiences). But
                  these Affiliates will honor the choices you make about who can see your information.</li>
                <li>We also may share your information as well as information from tools like cookies, log files, and device
                  identifiers and location data, with third-party organizations that help us provide the Service to you ("Service
                  Providers"). Our Service Providers will be given access to your information as is reasonably necessary
                  to provide the Service under reasonable confidentiality terms.</li>
                <li>We may also share certain information such as cookie data with third-party advertising partners. This information
                  would allow third-party ad networks to, among other things, deliver targeted advertisements that they believe
                  will be of most interest to you.</li>
                <li>
                  <p>We may remove parts of data that can identify you and share anonymized data with other parties. We may
                    also combine your information with other information in a way that it is no longer associated with you
                    and share that aggregated information.</p>
                  <p>
                    <strong>Parties with whom you may choose to share your User Content:</strong>
                  </p>
                </li>
                <li>
                  <p>Any information or content that you voluntarily disclose for posting to the Service, such as User Content,
                    becomes available to the public, as controlled by any applicable privacy settings that you set. To change
                    your privacy settings on the Service, please change your profile setting. Once you have shared User Content
                    or made it public, that User Content may be re-shared by others.</p>
                  <p>
                    <strong>What happens in the event of a change of control:</strong>
                  </p>
                </li>
                <li>
                  <p>If we sell or otherwise transfer part or the whole of WellBrain or our assets to another organization (e.g.,
                    in the course of a transaction like a merger, acquisition, bankruptcy, dissolution, liquidation), your
                    information such as name and email address, User Content and any other information collected through
                    the Service may be among the items sold or transferred. You will continue to own your User Content. The
                    buyer or transferee will have to honor the commitments we have made in this Privacy Policy and other
                    covenants provided by HIPAA.</p>
                  <p>
                    <strong>Responding to legal requests and preventing harm:</strong>
                  </p>
                </li>
                <li>
                  <p>We may access, preserve and share your information in response to a legal request (like a search warrant,
                    court order or subpoena) if we have a good faith belief that the law requires us to do so. This may include
                    responding to legal requests from jurisdictions outside of the United States where we have a good faith
                    belief that the response is required by law in that jurisdiction, affects users in that jurisdiction,
                    and is consistent with internationally recognized standards. We may also access, preserve and share information
                    when we have a good faith belief it is necessary to: detect, prevent and address fraud and other illegal
                    activity; to protect ourselves, you and others, including as part of investigations; and to prevent death
                    or imminent bodily harm. Information we receive about you may be accessed, processed and retained for
                    an extended period of time when it is the subject of a legal request or obligation, governmental investigation,
                    or investigations concerning possible violations of our terms or policies, or otherwise to prevent harm.</p>
                </li>
              </ul>
            </li>
            <li>
              <h2 id="how-we-store-your-information">How we store your information</h2>
              <p>
                <strong>Storage and Processing:</strong>
              </p>
              <ul>
                <li>Your information collected through the Service may be stored and processed in the United States or any other
                  country in which WellBrain, its Affiliates or Service Providers maintain facilities.</li>
                <li>WellBrain, its Affiliates, or Service Providers may transfer information that we collect about you, including
                  personal information across borders and from your country or jurisdiction to other countries or jurisdictions
                  around the world. If you are located in the European Union or other regions with laws governing data collection
                  and use that may differ from U.S. law, please note that we may transfer information, including personal
                  information, to a country and jurisdiction that does not have the same data protection laws as your jurisdiction.</li>
                <li>By registering for and using the Service you consent to the transfer of information to the U.S. or to any
                  other country in which WellBrain, its Affiliates or Service Providers maintain facilities and the use and
                  disclosure of information about you as described in this Privacy Policy.</li>
                <li>We use commercially reasonable safeguards to help keep the information collected through the Service secure
                  and take reasonable steps (such as requesting a unique password) to verify your identity before granting
                  you access to your account. We fully adhere to HIPAA policies and guidelines and keep all of our data encrypted,
                  including passwords.</li>
                <li>Please do your part to help us. You are responsible for maintaining the secrecy of your unique password and
                  account information, and for controlling access to emails between you and WellBrain, at all times. Your
                  privacy settings may also be affected by changes the social media services you connect to WellBrain make
                  to their services. We are not responsible for the functionality, privacy, or security measures of any other
                  organization.</li>
              </ul>
            </li>
            <li>
              <h2 id="your-choices-about-your-information">Your choices about your information</h2>
              <p>
                <strong>Your account information and profile/privacy settings:</strong>
              </p>
              <ul>
                <li>Update your account at any time by logging in and changing your profile settings.</li>
                <li>Unsubscribe from email communications from us by clicking on the "unsubscribe link" provided in such communications.
                  As noted above, you may not opt out of Service-related communications (e.g., account verification, purchase
                  and billing confirmations and reminders, changes/updates to features of the Service, technical and security
                  notices).</li>
                <li>
                  <p>For reviewing or modifying your account information you can do so via the website www.wellbrain.io or within
                    the app itself where you can change information accordingly. If you have other questions please contact
                    us at info@wellbrain.io.</p>
                  <p>
                    <strong>How long we keep your User Content:</strong>
                  </p>
                </li>
                <li>
                  <p>Following termination or deactivation of your account, WellBrain, its Affiliates, or its Service Providers
                    may retain information (including your profile information) and User Content for a commercially reasonable
                    time for backup, archival, and/or audit purposes.</p>
                </li>
                <li>If you need to delete your account you can contact us at info@wellbrain.io.</li>
              </ul>
            </li>
            <li>
              <h2 id="children-s-privacy">Children's Privacy</h2>
              <p> WellBrain does not knowingly collect or solicit any information from anyone under the age of 13 or knowingly
                allow such persons to register for the Service and/or as per . The Service and its content are not directed
                at children under the age of 13. In the event that we learn that we have collected personal information from
                a child under age 13 without parental consent, we will delete that information as quickly as possible. If
                you believe that we might have any information from or about a child under 13, please contact us. If you
                wish to have your children use your service we will follow the guidelines pursuant to the Children’s Online
                Privacy Protection Act (“COPPA”), where COPPA states that you must affirm that you have the authority to
                provide such consent. Generally, COPPA requires operators of websites and mobile applications to provide
                notice to and obtain the prior parental consent of a parent before collecting any personal information from
                children.</p>
            </li>
            <li>
              <h2 id="other-web-sites-and-services">Other web sites and services</h2>
              <p> We are not responsible for the practices employed by any websites or services linked to or from our Service,
                including the information or content contained within them. Please remember that when you use a link to go
                from our Service to another website or service, our Privacy Policy does not apply to those third-party websites
                or services. Your browsing and interaction on any third-party website or service, including those that have
                a link on our website, are subject to that third party's own rules and policies. In addition, you agree that
                we are not responsible and do not have control over any third-parties that you authorize to access your User
                Content. If you are using a third-party website or service and you allow them to access your User Content
                you do so at your own risk.</p>
            </li>
            <li>
              <h2 id="how-to-contact-us-about-a-deceased-user">How to contact us about a deceased user</h2>
              <p> In the event of the death of an WellBrain User, please contact us. We will usually conduct our communication
                via email; should we require any other information, we will contact you at the email address you have provided
                in your request.</p>
            </li>
            <li>
              <h2 id="how-to-contact-us">How to contact us</h2>
              <p> If you have any questions about this Privacy Policy or the Service, please find the appropriate support channel
                in the Help Center at which to contact us or at info@wellbrain.io.</p>
            </li>
            <li>
              <h2 id="changes-to-our-privacy-policy">Changes to our privacy policy</h2>
              <p>WellBrain may modify or update this Privacy Policy from time to time, so please review it periodically. We
                may provide you additional forms of notice of modifications or updates as appropriate under the circumstances.
                Your continued use of WellBrain or the Service after any modification to this Privacy Policy will constitute
                your acceptance of such modification.</p>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/privacypolicy/privacypolicy.component.html